var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input file",class:{ 'input-error': _vm.errors[_vm.id] }},[(_vm.name)?_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.name))]):_vm._e(),_vm._v(" "),_c('input',{ref:"file",attrs:{"id":_vm.id,"type":"file","accept":"image/png, image/jpeg, image/jpg, image/gif"},on:{"change":function($event){return _vm.handleFileUpload()}}}),_vm._v(" "),_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errors[_vm.id]))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-181f5a6a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Form/ImageUpload.vue
// module id = 676
// module chunks = 0